import React, { useState, useEffect } from "react";
import LogoSize from "./logoSize";
import DefaultLogoWrapper from "./defaultLogoWrapper";
import { defaultLogo } from "../logotypeQr/svg";
import LogoBackgroudToggle from "./logoBackgroudToggle";
import LogotypeNoneBtn from "./logotypeNoneBtn";
import LogotypeAddBtn from "./logotypeAddBtn";
import NewLogoItem from "./newLogoItem";
import { Col, Row } from "react-bootstrap";
import { setIsLogoModal } from "../../../../redux/slices/modals";
import { useDispatch, useSelector } from "react-redux";
import useCurrentLocation from "../../../../hooks/useCurrentLocation";
import ArtQrBanner from "../qrMode/ArtQrBanner";

function QrLogotype() {
  const lang = useSelector((state) => state.changeLang.language.stepThree);
  const logotype = useSelector((state) => state.qrSettings.logotype);

  const dispatch = useDispatch();
  const { entryLocation } = useCurrentLocation();
  const [logoShow, setLogoShow] = useState();
  let getSvg =
    logotype && defaultLogo.find((findElem) => findElem.id === logotype);

  useEffect(() => {
    if (!!getSvg === false && entryLocation) {
      setLogoShow(logotype);
    }
  }, []);

  const handleViewMore = () => {
    dispatch(setIsLogoModal(true));
  };

  return (
    <section className="bg-white p-3 p-md-4 mt-3 mt-lg-4 rounded-1" id="logo">
      <div className="fw-bold fs-4 mb-3 mb-md-4">{lang.showToggle[3]}</div>
      <Row className="g-2 g-lg-3 mb-3">
        <LogotypeNoneBtn />
        <NewLogoItem logoShow={logoShow} />
        <DefaultLogoWrapper logoShow={logoShow} />
      </Row>
      <div
        className="text-primary fs-7 text-center mb-4 mt-3 bg-white text-capitalize cursor-pointer"
        onClick={handleViewMore}
      >
        {lang.logo[2]}
      </div>
      <LogotypeAddBtn setLogoShow={setLogoShow} />
      <Row className="g-4 g-lg-3">
        <Col xs={12} md={6}>
          <LogoSize />
        </Col>
        <Col xs={12} md={6}>
          <LogoBackgroudToggle />
        </Col>
      </Row>

      <ArtQrBanner />
    </section>
  );
}

export default QrLogotype;
